<template>
  <div class="news-list">
    <!-- 分类列表 -->
    
    <div class="search-container">
      <div class="group-list">
        <div class="group-item" v-for="category in categories" :key="category" @click="selectCategory(category)" :class="{'active': selectedCategory === category}">
          <div>{{ category }}</div>
        </div>
      </div>
      <div class="container">
        <div class="search-header">
          <h2>新闻列表</h2>
          <div class="search-box">
            <input type="text" placeholder="请输入关键词搜索" v-model="searchKeyword" @keyup.enter="searchNews">
            <button @click="searchNews">搜索</button>
          </div>
        </div>
        
        <div class="news-items" v-loading="loading">
          <div class="news-item" v-for="item in newsList" :key="item.id" @click="viewNewsDetail(item.id)">
            <div class="news-image" v-if="item.picture">
              <img :src="item.picture" alt="新闻主图">
            </div>
            <div class="news-content" :class="{ 'full-width': !item.picture }">
              <h3>{{ item.title }}</h3>
              <p class="summary">{{ item.subtitle }}</p>
              <div class="meta">
                <span class="category">{{ item.category }}</span>
                <span class="date">{{ formatDate(item.create_time) }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 分页 -->
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="Number(total)">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchKeyword: '',
      categories: ['荣誉资讯','文化传承', '展会信息',  '公司资讯'],
      selectedCategory: ''
    }
  },
  methods: {
    // 选择分类
    selectCategory(category) {
      
      if (this.selectedCategory === category||category=='全部') {
        this.selectedCategory = '';
      } else {
        this.selectedCategory = category;
      }
      this.currentPage = 1;
      this.getNewsList();
    },
    
    // 获取新闻列表
    async getNewsList() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          keyword: this.searchKeyword
        };
        
        // 如果选择了分类，则添加分类参数
        if (this.selectedCategory) {
          params.category = this.selectedCategory;
        }
        
        const res = await this.$api.getNewsList(params)
        this.newsList = res.db || []
        this.total = res.total || 0
      } catch (error) {
        this.$warMsg('获取新闻列表失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    
    // 搜索新闻
    searchNews() {
      this.currentPage = 1
      this.getNewsList()
    },
    
    // 查看新闻详情
    viewNewsDetail(id) {
      // return
      this.$router.push(`/news/info/${id}`)
    },
    
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '--'
      return this.$hnwTools.formatDateTime(timestamp, 'ymd') || '--'
    },
    
    // 分页变化
    handlePageChange(page) {
      this.currentPage = page
      this.getNewsList()
    }
  },
  created() {
    this.getNewsList()
  }
}
</script>

<style lang="scss" scoped>
.news-list {
  background-color: #f5f5f5;
  min-height: calc(100vh - 80px);
  padding: 20px 0;
  
  .group-list {
    display: flex;
    width: 1200px;
    margin: 10px auto;
    background: #fff;
    .group-item {
      cursor: pointer;
      line-height: 38px;
      height: 38px;
      padding: 0 20px;
      color: #666666;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
    .active {
      color: #042273;
      >div {
        border-bottom: 2px solid #042273;
      }
    }
  }
  
  .search-container {
    // background: url('../../assets/newHome/banner.jpg') no-repeat center top;
    background-size: cover;
    padding-bottom: 20px;
    
    .container {
      width: 1200px;
      box-sizing: border-box;
      margin: 0 auto;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 8px;
      padding: 30px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      
      .search-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
        
        h2 {
          font-size: 24px;
          color: #333;
          font-weight: bold;
        }
        
        .search-box {
          display: flex;
          gap: 10px;
          
          input {
            width: 300px;
            padding: 10px 15px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            
            &:focus {
              outline: none;
              border-color: #063376;
            }
          }
          
          button {
            padding: 10px 20px;
            background-color: #063376;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            
            &:hover {
              background-color: #063376;
            }
          }
        }
      }
      
      .news-items {
        .news-item {
          padding: 10px 0;
          border-bottom: 1px solid #eee;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          overflow: hidden;
          &:hover {
            background-color: #f9f9f9;
            img{
              transform: scale(1.2);
              transition: all 0.6s ease;
            }
          }

          &:last-child {
            border-bottom: none;
          }

          .news-image {
            width: 20%;
            height: 120px;
            margin-right: 15px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 4px;
            }
          }

          .news-content {
            flex: 1;
            &.full-width {
              width: 100%; /* 当没有图片时，占据全部宽度 */
            }
            h3 {
              font-size: 18px;
              color: #333;
              margin-bottom: 10px;
              font-weight: bold;

              &:hover {
                color: #063376;
              }
            }

            .summary {
              font-size: 14px;
              color: #666;
              line-height: 1.6;
              margin-bottom: 15px;
            }

            .meta {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .category {
                background-color: #063376;
                color: white;
                padding: 3px 8px;
                border-radius: 3px;
                font-size: 12px;
              }

              .date {
                color: #999;
                font-size: 12px;
              }
            }
          }
        }
      }
      
      .pagination {
        text-align: center;
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #eee;
      }
    }
  }
}
</style>